import React from 'react';
import { Phone } from 'lucide-react';

const FloatingCallButton = () => {
  return (
    <a
      href="tel:9991129789"
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white rounded-full px-4 py-3 sm:px-5 sm:py-4 shadow-2xl transition-all duration-300 hover:scale-105 flex items-center gap-2 border-2 border-white"
      aria-label="Call Now"
      data-testid="floating-call-button"
    >
      <Phone className="w-5 h-5 sm:w-6 sm:h-6 animate-pulse" />
      <span className="font-bold text-sm sm:text-base whitespace-nowrap">Call Now</span>
    </a>
  );
};

export default FloatingCallButton;
